<div class="pdf-dialog-container">
  <div class="pdf-dialog-header">
    <h3>Anteprima Documento</h3>
    <button class="close-btn" (click)="closeDialog()">×</button>
  </div>
  <div class="pdf-dialog-body">
    <iframe 
      [src]="pdfUrl" 
      width="100%" 
      height="100%" 
      frameborder="0">
    </iframe>
  </div>
</div>
